import useBootstrapData from './useBootstrapData';

export default function useEnabledFeatures(): string[] | undefined {
  const bootstrapData = useBootstrapData();
  return bootstrapData?.enabled_features;
}
